module.exports = __webpack_public_path__ + "media/ppc/hero-african-american-female-811967e2.jpg";